export class QCmd {
  constructor() {
    this.fCmdCode = "0000";
    this.fWSMgr = null;
    this.fDoc = null;
    this.fSourcePanel = null;
    this.fSourceElement = null;
  }

  InitCommand(cmdCode, theElement, thePanel, theWSMgr, theDoc) {
    this.fCmdCode = cmdCode;
    this.fSourcePanel = thePanel;
    this.fSourceElement = theElement;
    this.fWSMgr = theWSMgr;
    this.fDoc = theDoc;
  }

  GetCmdCode() {
    return this.fCmdCode;
  }

  ChangeCmdCode(cmdCode) {
    this.fCmdCode = cmdCode;
  }

  GetSourcePanel() {
    return this.fSourcePanel;
  }

  GetSourceElement() {
    return this.fSourceElement;
  }

  GetWSMgr() {
    return this.fWSMgr;
  }

  GetDoc() {
    return this.fDoc;
  }
}
